<template>
  <div
    v-if="isProductDataLoadFail"
    class="pros-vertical"
    :style="{'--container-height': containerHeight}"
  >
    <Skeleton
      v-if="isProductDataLoading"
      :height="containerHeight"
    />
    <div :class="{ hidden: isProductDataLoading }">
      <h6
        v-if="title"
        class="grid-title"
        :class="{ 'text-center': titleCentered }"
      >
        {{ title }}
      </h6>
      <ProsGrid
        :config-data="getConfigData"
        :show-skeleton="false"
        @dataLoadStatusEvent="(e) => $emit('dataLoadStatusEvent', e)"
      />
    </div>
  </div>
</template>

<script>
import isBcom from '@common-vue/product-thumbnail/src/utils/isBcom';
import Skeleton from '@atomic-ui/skeleton';
import ProsGrid from '../ProsGrid/ProsGrid';
import constants from '../../utils/constants';

const { SMALL, MEDIUM, LARGE } = constants.BREAK_POINT_TYPE;

const impressionData = {
  media_type: 'PROS:standard panels',
  content_position: 'R00S00',
};

const PROS_ITEM_HEIGHT = 315;
const DEFAULT_CONTAINER_HEIGHT = 1395;

export default {
  name: 'ProsVertical',
  components: { ProsGrid, Skeleton },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['dataLoadStatusEvent'],
  data() {
    return {
      title: this.configData.title || '',
      numberOfItems: this.configData.numberOfItems || {
        [SMALL]: { row: 5, column: 1 },
        [MEDIUM]: { row: 5, column: 1 },
        [LARGE]: { row: 5, column: 1 },
      },
    };
  },
  computed: {
    isProductDataLoading() {
      return !this.$store.state.recommendationStore.panelLoadedMap[
        this.configData.workflow
      ]?.isLoaded;
    },
    isProductDataLoadFail() {
      return !this.$store.state.recommendationStore.panelLoadedMap[
        this.configData.workflow
      ]?.isFailed;
    },
    containerHeight() {
      return this.configData.maxProduct ? `${this.configData.maxProduct * PROS_ITEM_HEIGHT}px` : `${DEFAULT_CONTAINER_HEIGHT}px`;
    },
    getConfigData() {
      const defaultMaxProduct = 5;
      return {
        ...this.configData,
        impressionData,
        maxProduct: this.configData.maxProduct || defaultMaxProduct,
        numberOfItems: this.numberOfItems,
        recommendationData: this.configData.recommendationData || {},
        useWishList: this.configData.useWishList,
        title: '',
      };
    },
    titleCentered() {
      return isBcom && ['PDP_ZONE_A'].includes(this.configData.zone);
    },
  },
};
</script>

<style lang="scss">
.pros-vertical {
  .grid-title {
    margin-bottom: rem-calc(32);
  }
}
</style>

<style lang="scss" brand="mcom">
.pros-vertical {
  margin-left: auto;
  min-height: var(--container-height);

  .hidden {
    display: none;
    position: absolute;
  }

  .rating-average,
  .rating-description-nolink {
    display: none;
  }

  .grid-title {
    &::first-letter {
      text-transform: capitalize;
    }
  }
}
</style>

<style lang="scss" brand="bcom">
.pros-vertical {
  .hidden {
    display: none;
    position: absolute;
  }
  .grid-title {
    &.text-center {
      text-align: center;
    }
  }
}
</style>
